module.exports = __webpack_public_path__ + "5cd9f6b8ba9299b82be5ab3de679b25b.ico";